import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { CONTACT, NAV, SERVICES, LEGAL } from "../data/site";
import { useContents } from "../hooks/useContents";

export const Footer = () => {
  const c = useContents();
  const email = c("contact_email", CONTACT.email);
  return (
  <footer data-testid="site-footer" className="bg-graphite border-t border-steel">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 lg:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <img src="/images/logo-light.png" alt="Costruzioni Ciosko" className="h-16 w-auto" />
        <p className="mt-5 text-sm text-cement leading-relaxed">
          Costruzioni e lavorazioni edili in Veneto.
        </p>
        <p className="mt-4 text-[11px] text-cement/70 leading-relaxed" data-testid="footer-legal">
          {LEGAL.titolare}<br />{LEGAL.sede}<br />{LEGAL.cf}
        </p>
      </div>
      <nav aria-label="Link sito">
        <p className="overline-label mb-5">Navigazione</p>
        <ul className="space-y-2.5">
          {NAV.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-metal/75 hover:text-forest-glow transition-colors">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <nav aria-label="Servizi">
        <p className="overline-label mb-5">Servizi</p>
        <ul className="space-y-2.5">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/servizi#${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-metal/75 hover:text-forest-glow transition-colors">
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div>
        <p className="overline-label mb-5">Contatti</p>
        <ul className="space-y-3.5 text-sm">
          <li>
            <a href={`mailto:${email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-metal/75 hover:text-forest-glow transition-colors break-all">
              <Mail size={15} className="text-forest-glow shrink-0" /> {email}
            </a>
          </li>
          <li className="flex items-center gap-3 text-metal/75">
            <MapPin size={15} className="text-forest-glow shrink-0" /> Area operativa: {CONTACT.area}
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-steel">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-cement/70">© {new Date().getFullYear()} Costruzioni Ciosko. Tutti i diritti riservati.</p>
        <div className="flex items-center gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs text-cement/70 hover:text-forest-glow transition-colors">Privacy Policy</Link>
          <Link to="/cookie" data-testid="footer-cookie-link" className="text-xs text-cement/70 hover:text-forest-glow transition-colors">Cookie Policy</Link>
        </div>
      </div>
    </div>
    </footer>
  );
};
